export const REQUEST_PRODUCT="REQUEST_PRODUCT"
export const FAILURE_PRODUCT="FAILURE_PRODUCT"

export const GET_PRODUCT="GET_PRODUCT"